import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable
} from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminService } from '../../../../admin/admin.service';
import { ReportFieldOptionsService } from '../../../../datatools-settings/report-field-options/report-field-options/report-field-options.service';
import { DatatoolsLiteService } from '../../../../shared/services/datatools-lite.service';
import { DuplikitMergeService } from '../../../../shared/services/duplikit-merge.service';
import { MessageNotificationService } from '../../../../shared/services/message-notification.service';
import { UserInterfaceService } from '../../../../shared/services/user-interface.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { DuplicateService } from '../../../duplicate.service';
import { DuplikitReportField } from '../../duplikit-report-field';
import { GenericDuplicateDetailsComponent } from '../generic-duplicate-details.component';

@Component({
  selector: 'app-contact-duplicate-details',
  templateUrl: '../duplicate-details.component.html',
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatButton,
    NgClass,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatTooltip,
    DatePipe,
    MatPaginator,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    NgForOf
  ],
  styleUrls: ['../duplicate-details.component.scss']
})
export class ContactDuplicateDetailsComponent extends GenericDuplicateDetailsComponent {
  defaultFieldList: DuplikitReportField[] = [
    {
      dataType: 'ID',
      field: 'clientCorporation',
      label: 'Company',
      complex: [
        'clientCorporationName',
        'clientCorporationID'
      ]
    },
    { field: 'status', label: 'Status' },
    { field: 'dateAdded', label: 'Date Added', dataType: 'date' },
    { field: 'dateLastModified', label: 'Date Last Modified', dataType: 'date' },
    { field: 'dateLastComment', label: 'Date Last Note', dataType: 'date' },
    { field: 'dateLastPlaced', label: 'Date Last Placement', dataType: 'date' },
    { field: 'address1', label: 'Address 1' },
    { field: 'city', label: 'City' },
    { field: 'state', label: 'State' },
    { field: 'zip', label: 'Zip Code' },
    { field: 'email', label: 'Email' },
    { field: 'email 2', label: 'Email 2' },
    { field: 'email 3', label: 'Email 3' },
    { field: 'phone', label: 'Phone' },
    { field: 'phone 2', label: 'Phone 2' },
    { field: 'phone 3', label: 'Phone 3' },
    { field: 'mobile', label: 'Mobile' },
    { field: 'owner', label: 'Owner', dataType: 'ID', complex: ['ownerName', 'ownerId']},
  ];

  constructor(
      messageNotificationService: MessageNotificationService,
      duplicateService: DuplicateService,
      adminService: AdminService,
      dataToolsLiteService: DatatoolsLiteService,
      reportFieldOptionsService: ReportFieldOptionsService,
      utilsService: UtilsService,
      duplikitMergeService: DuplikitMergeService,
      userInterfaceService: UserInterfaceService,
  ) {
    super(
        messageNotificationService,
        duplicateService,
        adminService,
        dataToolsLiteService,
        reportFieldOptionsService,
        utilsService,
        duplikitMergeService,
        userInterfaceService
    );
  }
}
